import { queryOptions } from '@tanstack/react-query';

import { BlockApi } from '@api/BlockApi';

import { normalizeBlock } from '../utils/blockData';

export const blockKeys = {
    all: ['editBlock'] as const,
    versions: () => [...blockKeys.all, 'version'] as const,
    version: (blockId: string, version: number) => [...blockKeys.versions(), blockId, version] as const,
};

export const blockQueryOptions = {
    version: (blockId: string, version: number) =>
        queryOptions({
            // Кэш работает буфером редактирования: правки пишутся в него до сохранения,
            // фоновый рефетч затёр бы несохранённое.
            staleTime: Infinity,
            queryKey: blockKeys.version(blockId, version),
            queryFn: async () => normalizeBlock(await BlockApi.getBlockVersion(blockId, version)),
        }),
};
